import { serialize } from "object-to-formdata";
import request from "../../utils/request";
import {
  UserAttachmentInput,
  UserAttachmentView,
  UserAttachmentAccessInput,
  CompanyAttachmentTypeInput,
  CompanyAttachmentTypeView,
  FileAnalysisResult,
  Result,
} from "../../models/general";

export async function getUserAttachments(userId: string) {
  const response = await request.get<Result<UserAttachmentView[]>>("Attachment/GetUserAttachments", {
    params: { userId },
  });
  return response.data;
}

export async function uploadAttachment(input: UserAttachmentInput) {
  const response = await request.post<Result<UserAttachmentView>>("Attachment/UploadAttachment", serialize(input));
  return response.data;
}

export async function previewAttachment(id: number) {
  const response = await request.get<Blob>(`Attachment/PreviewAttachment/${id}`, {
    responseType: 'blob',
  });
  return response.data;
}

export async function downloadAttachment(id: number) {
  const response = await request.get<Blob>(`Attachment/DownloadAttachment/${id}`, {
    responseType: 'blob',
  });
  return response.data;
}

export async function shareAttachment(input: UserAttachmentAccessInput) {
  const response = await request.post<Result<UserAttachmentView>>("Attachment/ShareAttachment", input);
  return response.data;
}

export async function editAttachment(id: number, input: UserAttachmentInput) {
  const response = await request.post<Result<UserAttachmentView>>(`Attachment/EditAttachment/${id}`, serialize(input));
  return response.data;
}

export async function deleteUserAttachment(id: number) {
  const response = await request.post<Result<UserAttachmentView>>(`Attachment/DeleteUserAttachment/${id}`);
  return response.data;
}

export async function editAttachmentAccess(input: UserAttachmentAccessInput) {
  const response = await request.post<Result<UserAttachmentView>>("Attachment/EditAttachmentAccess", input);
  return response.data;
}

export async function revokeAttachmentAccess(input: UserAttachmentAccessInput) {
  const response = await request.delete<Result<UserAttachmentView>>("Attachment/RevokeAttachmentAccess", {
    data: input,
  });
  return response.data;
}

export async function getCompanyAttachmentTypes() {
  const response = await request.get<Result<CompanyAttachmentTypeView[]>>("Attachment/GetCompanyAttachmentTypes");
  return response.data;
}

export async function addCompanyAttachmentTypes(input: CompanyAttachmentTypeInput[]) {
  const response = await request.post<Result<CompanyAttachmentTypeView[]>>("Attachment/AddAttachmentTypes", input);
  return response.data;
}

export async function editCompanyAttachmentTypes(input: CompanyAttachmentTypeInput[]) {
  const response = await request.post<Result<CompanyAttachmentTypeView[]>>("Attachment/EditAttachmentTypes", input);
  return response.data;
}

export async function analyzeFile(file: File) {
  const formData = new FormData();
  formData.append("file", file);
  const response = await request.post<Result<FileAnalysisResult>>(
    "Attachment/AnalyzeFile",
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return response.data;
}

export async function previewAttachmentFile(fileId: number) {
  const response = await request.get<Blob>(`Attachment/PreviewAttachmentFile/${fileId}`, {
    responseType: 'blob',
  });
  return response.data;
}

export async function downloadAttachmentFile(fileId: number) {
  const response = await request.get<Blob>(`Attachment/DownloadAttachmentFile/${fileId}`, {
    responseType: 'blob',
  });
  return response.data;
}

export async function removeAttachmentFile(fileId: number) {
  const response = await request.post<Result<boolean>>(`Attachment/RemoveAttachmentFile/${fileId}`);
  return response.data;
}
